export const handleError = (enqueueSnackbar: any, err: any) => {
  if (err.response.data && err.response.data.message) {
    enqueueSnackbar(err.response.data.message, {
      variant: 'error',
    });
  } else {
    enqueueSnackbar(err.message, {
      variant: 'error',
    });
  }
};
